var React = require('react');

function IconLink (props) {
    return React.createElement("svg",props,React.createElement("path",{"strokeLinecap":"round","strokeLinejoin":"round","d":"M7 20l4-16m2 16l4-16M6 9h14M4 15h14"}));
}

IconLink.defaultProps = {"fill":"none","viewBox":"0 0 24 24","stroke":"currentColor","strokeWidth":"2"};

module.exports = IconLink;

IconLink.default = IconLink;
